export default "__VITE_ASSET__BG2kDyI8__"